import request from '@/utils/request'
// const homeApi = '/ApiClintHome'

// 首页轮播图
export function getIndexPageImgs(data) {
    return new Promise((resolve, reject) => {
        return request.post({
            url: '/WebInformation/ApiBanner',
            data: data
        }).then(res => {
            if (res) {
              resolve(res)
            }
        }).catch(err => {
            console.log(err);
            reject(err)
        });
    });
}

// 行业类别
export function IndustryType(data) {
    return new Promise((resolve, reject) => {
        return request.post({
            url: '/WebCommon/GetDictionary',
            data: data
        }).then(res => {
            if (res) {
              resolve(res)
            }
        }).catch(err => {
            console.log(err);
            reject(err)
        });
    });
}
// 热招职位
export function GetHotPosition(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebPosition/GetWebPagging',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}
// 热招企业
export function GetHotEnterprise(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCompany/GetWebPagging',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 推荐职位
export function GetRecommendPosition(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebPosition/GetRecommendPosition',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 职位detal
export function GetPosition(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebPosition/GetPosition',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 收藏
export function CollectPosition(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebPosition/CollectPosition',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 取消收藏
export function CancelCollectPosition(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebPosition/CancelCollectPosition',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 热门企业
export function GetEnterprise(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCompany/GetWebPagging',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 企业详情
export function GetCompany(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCompany/GetCompany',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 在招职位
export function GetCompanyOpenPosition(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCompany/GetCompanyOpenPosition',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 关注
export function FollowCompany(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCompany/FollowCompany',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 取消关注
export function CancelFollowCompany(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCompany/CancelFollowCompany',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}